import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { Link } from 'react-router-dom';
import masterField from '../../../../../components/search-form/master-field';


class DateField extends Component {
  render() {
    return (
      <div>
        <Fa name="check-square" /> Contacts that match <Link to="/setup/custom-do-not-contact-field">these settings</Link> will NOT be submitted.
      </div>
    );
  }
}

DateField.propTypes = {
  submitting: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};
DateField.defaultProps = {
  disabled: false,
  submitting: false,
  onChange: () => {},
};
export default masterField(DateField);
